<template>
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
            <div class="alertContainer">
                <div class="alertHeader">
                    <img src="@/assets/fi_2797387.svg" width="36px" alt="">
                    <h3>Alert</h3>
                </div>
                <div class="alertBody" v-html="message">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        content: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            message: ''
        };
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    mounted() {
        this.message = this.$props.content.replaceAll('\n', '<br>').replaceAll('[[', '<b>').replaceAll(']]', '</b>')
    }
}
</script>

<style>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.alertContainer {
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: #fff;
    align-items: center;
    justify-content: center;
    margin: 16px;
    border-radius: 8px;
}

.alertHeader {
    font-size: 20px;
    font-weight: bold;
    color: #E2392C;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
    align-items: center;
    margin-bottom: 16px;
}

.modal-content {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.skip-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #222;
    color: white;
    border: none;
    height: 32px;
    width: 32px;
    border-radius: 32px;
    cursor: pointer;
}
</style>